import {
  DataProvider,
  GetListResult,
  GetManyParams,
  GetManyResult,
  GetOneParams,
  GetOneResult,
} from 'react-admin'
import { SYSTEM_LOGS_URL } from '../../api-urls'
import { get, getWithPagination } from '../../common/fetch.utils'
import {
  filterParamsComposer,
  queryParamsComposer,
} from '../../common/get-by-conditions.utils'
import { TicketAPIGetListParams } from '../../common/ticket-api-get-list.params'
import { SystemLogDto } from '../../dto/system-notifications/system-log.dto'
import { mapSortLogParam } from './system-log-sort.mapper'
import filterMapper from './system-log.filter.mapper'

const provider = {
  getList: async (
    resource: string,
    { filter, sort, pagination }: TicketAPIGetListParams,
  ): Promise<GetListResult<SystemLogDto>> => {
    const filterParams = `o=>${filterParamsComposer(
      'o',
      { ...filter, notified: filter?.notified ?? true },
      filterMapper,
    )}`
    const pathParams = queryParamsComposer(sort, pagination, mapSortLogParam)
    const path = `/${filterParams}${(pathParams && `?${pathParams}`) || ''}`

    const {
      data,
      range: { total },
    } = await getWithPagination<SystemLogDto[]>(
      `${SYSTEM_LOGS_URL}/GetByConditions`,
      path,
    )

    return Promise.resolve({
      data,
      total,
    })
  },
  getOne: async (
    resource: string,
    { id }: GetOneParams,
  ): Promise<GetOneResult<SystemLogDto>> => {
    const data = await get<SystemLogDto>(SYSTEM_LOGS_URL, `/${id}`)
    return Promise.resolve({
      data,
    })
  },
  getMany: async (
    resource: string,
    { ids }: GetManyParams,
  ): Promise<GetManyResult<SystemLogDto>> => {
    const data = await get<SystemLogDto[]>(
      SYSTEM_LOGS_URL,
      `/GetByConditions/e=>new int[] {${ids.toString()}}.Contains(e.Id)`,
    )
    return Promise.resolve({ data })
  },
} as DataProvider

export default provider
